import asyncSeries from 'async/series';
import { EventEmitter } from 'events';

import util from '../tools/util';
import Storage from '../tools/storage';
import WalletConnect from '../tools/wallet_connect';
import EthBrowser from '../tools/eth_browser';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  hasWallet,
  getAddress,
  getWalletType,
  createWalletConnect,
  cancelWalletConnect,
  createEthBrowser,
  deleteWallet,
  sendTransaction,
};

const WALLET_KEY = 'HARBOUR_SWAP_WALLET';

let g_wallet = null;
let g_isWalletConnectRunning = false;

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  Storage.getItem(WALLET_KEY, (err, data) => {
    if (!err && data) {
      g_wallet = data;
      if (g_wallet.wallet_type === 'WEB3') {
        if (!EthBrowser.isAvailable()) {
          g_wallet = null;
        }
      }
    }
    done && done();
  });
  WalletConnect.addChangeListener(_onWalletConnectChange);
}
function _onWalletConnectChange(reason, url) {
  if (reason === 'connect_url' && g_isWalletConnectRunning) {
    _emit('connect_url', url);
  }
}
function hasWallet(): boolean {
  return Boolean(getAddress());
}
function getAddress(): string {
  return (g_wallet && g_wallet.wallet_addr) || '';
}
function getWalletType(): string {
  return (g_wallet && g_wallet.wallet_type) || '';
}

function createWalletConnect(done) {
  let wallet_addr;
  let wallet_session;
  g_isWalletConnectRunning = true;
  asyncSeries(
    [
      (done) => {
        const opts = {
          //chainId: CHAIN_ID,
        };
        WalletConnect.connect(opts, (err, extra) => {
          if (err) {
            util.errorLog('WalletStore.createWalletConnect: connect err:', err);
          } else {
            wallet_addr = WalletConnect.getAddress();
            wallet_session = WalletConnect.getSession();
            util.debugLog('connect success:', wallet_addr, wallet_session);
            if (!wallet_addr) {
              err = 'bad_addr';
            }
            if (!wallet_session) {
              err = 'bad_session';
            }
          }
          done(err);
        });
      },
      (done) => {
        g_wallet = {
          wallet_type: 'WALLETCONNECT',
          wallet_addr,
          wallet_session,
        };
        Storage.setItem(WALLET_KEY, g_wallet, done);
      },
    ],
    (err) => {
      g_isWalletConnectRunning = false;
      if (!err) {
        _emit('connect');
      }
      done(err);
    }
  );
}
function cancelWalletConnect() {
  WalletConnect.cancelConnect();
}

function deleteWallet() {
  g_wallet = {
    is_disconnected: true,
  };
  Storage.setItem(WALLET_KEY, g_wallet);
  _emit('delete');
}
function _walletConnectInit(done) {
  if (WalletConnect.isConnected()) {
    done();
  } else if (g_wallet) {
    const session = util.jsonParse(g_wallet.wallet_session);
    WalletConnect.reconnect(session, done);
  } else {
    done('no_wallet');
  }
}
function createEthBrowser(done) {
  let wallet_addr: string;
  asyncSeries(
    [
      (done) => {
        const opts = {};
        EthBrowser.connect(opts, (err) => {
          if (err) {
            util.errorLog('WalletStore.createEthBrowser: connect err:', err);
          } else {
            wallet_addr = EthBrowser.getAddress();
            if (!wallet_addr) {
              err = 'bad_addr';
            }
          }
          done(err);
        });
      },
      (done) => {
        g_wallet = {
          wallet_type: 'WEB3',
          wallet_addr,
        };
        Storage.setItem(WALLET_KEY, g_wallet, done);
      },
    ],
    (err) => {
      if (!err) {
        _emit('connect');
      }
      done(err);
    }
  );
}
function sendTransaction(tx, done) {
  tx.from = getAddress();
  const { wallet_type } = g_wallet;

  let transaction_hash: string;
  asyncSeries(
    [
      (done) => {
        if (wallet_type === 'WALLETCONNECT') {
          _walletConnectInit(done);
        } else {
          done();
        }
      },
      (done) => {
        if (wallet_type === 'WALLETCONNECT') {
          WalletConnect.ethSend(tx, (err, hash) => {
            transaction_hash = hash;
            done(err);
          });
        } else if (wallet_type === 'WEB3') {
          EthBrowser.ethSend(tx, (err, hash) => {
            transaction_hash = hash;
            done(err);
          });
        } else {
          done('not_supported');
        }
      },
    ],
    (err) => {
      if (err) {
        util.errorLog('WalletStore.sendTransaction: err:', err);
      }
      done(err, transaction_hash);
    }
  );
}
